<template>
    <div class="kit-total">
        <div class="kit-total__discount" v-show="$store.getters.getCartDiscount">
            <label>Discount ( {{ $store.state.current.discount }}% )</label>

            <var>
                -
                <data v-html="$store.state.currency"></data>
                {{ discount }}
            </var>
        </div>
        <div class="kit-total__total" v-show="total">
            <label>Total (Ex. VAT)</label>
            <var>
                <data v-html="$store.state.currency"></data>
                {{ total }}
            </var>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Total',
        computed: {
            discount() {
                return this.$store.getters.priceFormatter(this.$store.getters.getCartDiscount);
            },

            total() {
                const total = this.$store.getters.getCartTotal;

                if (total === 0) return false;

                if (this.$store.getters.getCartDiscount) {
                    total - this.$store.getters.getCartDiscount;
                }

                return this.$store.getters.priceFormatter(total);
            }
        }
    }
</script>

<style lang="scss">
    .kit {
        &-total {
            padding-top: 24px;

            > div {
                display: flex;
                justify-content: space-between;
                font-size: 14px;
                line-height: 22px;
                padding: 10px 0;

                &:last-child {
                    border-top: 1px solid #E5E7EC;
                }
                
                var {
                    font-style: normal;
                    font-size: 14px;
                    font-weight: 700;
                    line-height: 22px; 
                }
            }

            &__total {
                var {
                    color: #F97623;
                }
            }
        }
    }
</style>